import { observer } from 'mobx-react-lite';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@workspace/ui/lib/utils';

import { BellIcon } from '~/components/MarketplaceIcons';
import { useNotifyMe } from '~/hooks/useNotifyMe';

interface Props {
  productId: number;
  sku: string;
}

const NotifyBellView = ({ productId, sku }: Props) => {
  const { t } = useTranslation();
  const { notifyMeOnClick, isSubscribed, isLoading } = useNotifyMe(
    productId,
    sku,
    false,
  );

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    notifyMeOnClick();
  };

  return (
    <button
      type="button"
      aria-label={t('notifyMe')}
      aria-pressed={isSubscribed}
      disabled={isLoading}
      onClick={handleClick}
      className={cn(
        'absolute right-3 bottom-3 z-[2] flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-[8px] border-0 p-0 transition-colors duration-[120ms] ease-[cubic-bezier(.22,1,.36,1)] disabled:cursor-default',
        isSubscribed
          ? 'bg-action-brand text-white'
          : 'bg-compact-control text-text-primary hover:bg-action-brand hover:text-white',
      )}
    >
      <BellIcon filled={isSubscribed} className="size-4" />
    </button>
  );
};

export const NotifyBell = observer(NotifyBellView);
